import { render, staticRenderFns } from "./SubmitBtn.vue?vue&type=template&id=666a5c60&scoped=true&"
import script from "./SubmitBtn.vue?vue&type=script&lang=js&"
export * from "./SubmitBtn.vue?vue&type=script&lang=js&"
import style0 from "./SubmitBtn.vue?vue&type=style&index=0&id=666a5c60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666a5c60",
  null
  
)

export default component.exports